import { IStackProps } from "@fluentui/react";
import { ECompareConfigurationExpandOptions, ICompareConfiguration } from "../CompareLookupDialog/CompareLookupDialog";

export interface IMarkerSet {
    MARKER_OFF: string;
    MARKER_ON: string;
}

export const CONST_MARKER_OFF = '⚫ ';
export const CONST_MARKER_OFF_DARK = '⚪ ';
export const CONST_MARKER_ON = '🟡 ';

export const QUICK_NAV_OVERLAY_VISIBLE_STYLE: React.CSSProperties = {
    height: '100vh',
    width: '100%',
    position: 'fixed',
    backgroundColor: 'rgba(0,0,0,0.92)',
    left: '0',
    top: '0',
    overflowY: 'auto',
    transition: '0.6s',
    zIndex: 100000,
    display: 'block',
};

export const ORIGIN_TITLE = 'Origin';
export const TARGET_TITLE = 'Target';
export const ACTION_TITLE = 'Action';



export const STICKY_HEADER_HEIGHT = 45;


export const STACK_DEFAULT_PROPS: IStackProps = {
    tokens: { childrenGap: '8px' },
    style: { marginBottom: '5px', marginTop: '5px' }
}


export const shouldIncludeComparisonItem = (showDifferencesOnly: boolean, changed?: boolean) => (
    !showDifferencesOnly || !!changed
);

export const getDefaultCollapsed = (configuration: ICompareConfiguration, changed?: boolean) => {

    if (configuration.expandMode === ECompareConfigurationExpandOptions.all) {
        return false;
    }

    if (configuration.expandMode === ECompareConfigurationExpandOptions.differences) {
        return !changed;
    }

    return true;
};
